function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { TableList, TextButton, useGlobalContext } from 'seagull';
import { EditNotificationSettingsModal } from "./EditNotificationSettingsModal";
import { getNotificationsToShow, Table } from "./NotificationSettings.utils";
import { EditMode, NotificationSettingsEntryType } from "../../models/notification-settings/model";
import { useStore } from "../../contexts";
import { selectors } from "../../store/state-selectors";
import styles from "./NotificationSettingsTable.module.scss";
const typeMap = {
  [Table.Reminders]: NotificationSettingsEntryType.Recurring,
  [Table.Notifications]: NotificationSettingsEntryType.Single
};
export const NotificationSettingsTable = _ref => {
  let {
    data,
    tableType,
    columnDefs,
    selectedTab,
    headerItems,
    refresh,
    getRowItems
  } = _ref;
  const globalContext = useGlobalContext();
  const showKarbonIntegration = useStore(selectors.integration.showKarbonIntegration);
  const showClientHubIntegration = useStore(selectors.integration.showClientHubIntegration);
  const showFinancialCentsIntegration = useStore(selectors.integration.showFinancialCentsIntegration);
  const notificationsTextMap = getNotificationsToShow({
    tab: selectedTab,
    showKarbonIntegration,
    showClientHubIntegration,
    showFinancialCentsIntegration
  });
  const handleEditClick = props => {
    globalContext.showModal({
      closeOnClickOutside: true,
      closeOnEscapeKey: true,
      content: _ref2 => {
        let {
          dismissModal
        } = _ref2;
        return /*#__PURE__*/React.createElement(EditNotificationSettingsModal, _extends({
          selectedTab: selectedTab,
          dismissModal: dismissModal
        }, props));
      }
    });
  };
  return /*#__PURE__*/React.createElement(TableList.Provider, {
    columnDefs: columnDefs,
    hasActionColumn: true
  }, /*#__PURE__*/React.createElement(TableList.Header, {
    bgColor: "darkGray",
    items: headerItems,
    "data-testid": "".concat(tableType, "-table-header"),
    className: styles.header
  }), Object.entries(notificationsTextMap).map(_ref3 => {
    let [key, text] = _ref3;
    const notification = data[selectedTab][key];
    return notification && notification.type === typeMap[tableType] && /*#__PURE__*/React.createElement(TableList.Row, {
      key: key,
      size: "fluid",
      items: getRowItems({
        notification,
        text,
        key
      }),
      "data-testid": "".concat(Table.Notifications, "-row-").concat(key),
      className: styles.row,
      actionColumn: notification.editMode === EditMode.Enabled && /*#__PURE__*/React.createElement(TextButton, {
        onClick: () => handleEditClick({
          tableType,
          notification,
          notificationText: text,
          notificationName: key,
          refresh
        }),
        underline: "none",
        "data-testid": "".concat(tableType, "-row-").concat(key, "-edit")
      }, "Edit")
    });
  }));
};